module.exports = __webpack_public_path__ + "static/ThoreauBeta1.9-DisplayRegular-07c5c76b9c5014b2fa604c8d9f3fe957.eot";